import React from 'react';
import { TypedMemo } from '../../common/types';
import { UpsellAutoModalHost } from './auto/UpsellAutoModalHost';
import { WatermarkChoiceHost } from './choice/WatermarkChoiceHost';
import { useRememberWatermarkSummary } from './useRememberWatermarkSummary';
import { useUpsellQueryParam } from './useUpsellQueryParam';
import { useWatermarkSummaryRealtime } from './useWatermarkSummaryRealtime';

/**
 * The one mount of the trial upsell in the app shell (`SMLContainer`, signed in only): it keeps
 * the watermark summary fresh and keeps it for the payment return page, opens the offer of `?upsell=watermark`, draws the choice of a file
 * use (design a2) and the one automatic modal of the session (designs a1, b3).
 */
const WatermarkUpsellHostComponent: React.FC = () => {
  useWatermarkSummaryRealtime();
  useRememberWatermarkSummary();
  useUpsellQueryParam();
  return (
    <>
      <WatermarkChoiceHost />
      <UpsellAutoModalHost />
    </>
  );
};

export const WatermarkUpsellHost = TypedMemo(WatermarkUpsellHostComponent);
